const handleError = (error) => {
	console.log(error);
};

export default handleError;
